module.exports = __webpack_public_path__ + "bv.f7bdc1edcef008357c09.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bv.svg
// module chunks = styles